import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sparkles, ArrowRight } from 'lucide-react';

export const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isLanding = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/60 bg-white/80 backdrop-blur-2xl" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group">
          <div className="h-9 w-9 rounded-lg bg-teal-500 flex items-center justify-center">
            <Sparkles className="h-5 w-5 text-white" />
          </div>
          <span className="text-xl font-bold text-slate-900 tracking-tight">Ariskool</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {[
            { label: 'Features', path: '/features' },
            // { label: 'Pricing', path: '/pricing' },
            { label: 'Tutorials', path: '/tutorials' },
            { label: 'Contact', path: '/contact' },
          ].map((item) => (
            <Button
              key={item.path}
              variant="ghost"
              className={`text-sm rounded-lg ${
                location.pathname === item.path
                  ? 'text-teal-700 bg-teal-50'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
              }`}
              onClick={() => navigate(item.path)}
              data-testid={`header-${item.label.toLowerCase()}-btn`}
            >
              {item.label}
            </Button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Button
            variant="ghost"
            className="text-sm text-slate-600 hover:text-slate-900"
            onClick={() => navigate('/login')}
            data-testid="header-login-btn"
          >
            Log In
          </Button>
          <Button
            className="bg-teal-600 hover:bg-teal-500 text-white font-semibold rounded-full px-5 text-sm"
            onClick={() => navigate('/register')}
            data-testid="header-cta-btn"
          >
            Get Started
            <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </div>
      </div>
    </header>
  );
};
